export const travelSpendingQuestions: Record<string, any> = {
  travelSpending: {
    labelKey: 'applicationForm.TRAVEL_EXPENSES.travelSpending.label',
    booleanQuestionFormKey: 'hasTravelSpending',
    adornmentKey: 'common.monthly',
    explanationKey: 'applicationForm.TRAVEL_EXPENSES.travelSpending.explanation',
    options: [
      { labelKey: 'common.yes', value: 'true' },
      { labelKey: 'common.no', value: 'false' },
    ],
  },
};
